import React from "react";
import Link from "next/link";
import styled from "styled-components";
import slugify from "slugify";

const Box = styled.div`
  padding: 20px;
  background-color: #f5f5f5;
`;

const Title = styled.p`
  margin: 0;
  font-size: 22px;
  line-height: 26px;
  font-weight: 900;
  padding-bottom: 10px;
  border-bottom: 1px solid #c5c5c5;
`;

const Tag = styled.span`
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: #4762ab;
  color: #fff;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
`;

const BoxTags = ({ tags }) => {
  if (!tags.length) {
    return null;
  }
  return (
    <Box>
      <Title>Tagi</Title>
      {tags.map((el) => {
        const slug = slugify(el).toLocaleLowerCase();
        return (
          <Link
            key={slug}
            href={"/artykuly/tagi/[tag]"}
            as={`/artykuly/tagi/${slug}`}
            passHref={true}
          >
            <a>
              <Tag>{el}</Tag>
            </a>
          </Link>
        );
      })}
    </Box>
  );
};

export default BoxTags;
